// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","text":"footer_text__9aNvQ","icons":"footer_icons__00kbw"};